export default "__VITE_ASSET___4I$R3lA__"